import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Calculator } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';

interface InvoiceProgressSummaryProps {
  estimateTotal: number;
  totalInvoiced: number;
  remainingBalance: number;
}

const InvoiceProgressSummary: React.FC<InvoiceProgressSummaryProps> = ({
  estimateTotal,
  totalInvoiced,
  remainingBalance
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calculator className="h-5 w-5" />
          Invoice Progress Summary
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <p className="text-sm text-muted-foreground">Estimate Total</p>
            <p className="text-2xl font-bold">{formatCurrency(estimateTotal)}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Total Invoiced</p>
            <p className="text-2xl font-bold text-blue-600">{formatCurrency(totalInvoiced)}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Remaining Balance</p>
            <p className="text-2xl font-bold text-green-600">{formatCurrency(remainingBalance)}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Progress</p>
            <p className="text-lg font-semibold">
              {estimateTotal > 0 ? ((totalInvoiced / estimateTotal) * 100).toFixed(2) : 0}%
            </p>
            <Badge variant={remainingBalance > 0 ? "secondary" : "default"}>
              {remainingBalance > 0 ? "Partial" : "Complete"}
            </Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default InvoiceProgressSummary;
